import { createSelector } from "@reduxjs/toolkit";
import selectPaymentsRaw from "./selectPaymentsRaw";

export default createSelector(selectPaymentsRaw, ({ creatorProduct }) => creatorProduct);
